import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const DealDeDuplicatorPage = withSuspense(lazy(() => import('./deal-deduplicator')));
export default DealDeDuplicatorPage;
